import { useCallback } from 'react'
import Papa from 'papaparse'
import { summaryForOutsourcing } from '../../utils/functions/summaryForOutsorcing'

const headers = [
  '制作番号1',
  '制作番号2',
  '作業開始日',
  '現場名',
  '作業開始時間',
  '作業終了時間',
  '残業時間',
  '定時',
  '合計作業時間(時間)',
  '合計作業時間(分)',
  '日曜・祝日',
  '曜日',
  '仕入先コード',
  '仕入先略称',
  '作業者番号',
  '作業者名',
  '備考',
]

const useCsvExporter = () => {
  const exportCsv = useCallback(
    (data: summaryForOutsourcing[][], filename: string) => {
      const flattenedData = data.flat() // ネストされた配列をフラット化
      const csvData = flattenedData.map((entry) => ({
        制作番号1: entry.productNo,
        制作番号2: entry.productBno,
        作業開始日: entry.date,
        現場名: entry.siteName,
        作業開始時間: entry.startTime,
        作業終了時間: entry.endTime,
        残業時間: entry.overTime,
        定時: entry.regularTime,
        '合計作業時間(時間)': entry.totalWorkingTimeByHour,
        '合計作業時間(分)': entry.totalWorkingTimeByMinute,
        '日曜・祝日': entry.isHoliday,
        曜日: entry.weekDay,
        仕入先コード: entry.supplierId,
        仕入先略称: entry.supplierShortName,
        作業者番号: entry.workerId,
        作業者名: entry.workerName,
        備考: entry.remarks,
      }))

      // CSVデータを変換
      const bom = '\uFEFF' // BOMの追加（Excel互換用）
      const csv = bom + Papa.unparse({ fields: headers, data: csvData })

      // 現在の日時をファイル名に追加
      const now = new Date()
      const timestamp = formatDateForFilename(now)
      const fullname = `${filename}_${timestamp}.csv`

      // Blobを作成してダウンロード
      const csvFile = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const downloadLink = document.createElement('a')
      downloadLink.href = URL.createObjectURL(csvFile)
      downloadLink.setAttribute('download', fullname)
      document.body.appendChild(downloadLink)
      downloadLink.click()
      document.body.removeChild(downloadLink)
    },
    []
  )

  return { exportCsv }
}

const formatDateForFilename = (date: Date) => {
  const year = date.getFullYear()
  const month = `0${date.getMonth() + 1}`.slice(-2)
  const day = `0${date.getDate()}`.slice(-2)
  const hour = `0${date.getHours()}`.slice(-2)
  const minute = `0${date.getMinutes()}`.slice(-2)
  const second = `0${date.getSeconds()}`.slice(-2)

  return `${year}${month}${day}_${hour}${minute}${second}`
}

export default useCsvExporter
